import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'wall',
      d: 'M-2,-3h0.5v0.5h-0.5zM-0.5,-3h0.5v0.5h-0.5zM-2.5,-2.5h2.5v0.5h-2.5zM-2.5,-2h0.5v1.5h-0.5zM-1,-2h1v2.5h-1zM-3,-0.5h1v0.5h-1z',
    },
    { paint: 'wallShade', d: 'M1,-3.5h1v0.5h-1zM0,-3h1.5v3h-1.5zM0,0h1v0.5h-1z' },
    {
      paint: 'roofB',
      d: 'M-1.5,-6.5h2v0.5h-2zM-2,-6h3v0.5h-3zM-2.5,-5.5h4v0.5h-4zM-2.5,-5h4.5v0.5h-4.5zM-3,-4.5h5v0.5h-5zM-2.5,-4h3.5v0.5h-3.5zM-1.5,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M2,-4.5h0.5v0.5h-0.5zM-3.5,-4h1v0.5h-1zM1,-4h2v0.5h-2zM4,-4h0.5v0.5h-0.5zM-1,-3.5h2v0.5h-2zM2,-3.5h3.5v0.5h-3.5zM1.5,-3h1v0.5h-1zM4.5,-3h1v0.5h-1zM1.5,-2.5h0.5v0.5h-0.5zM5,-2.5h0.5v0.5h-0.5zM1.5,-2h1.5v0.5h-1.5zM4,-2h2v0.5h-2zM-2,-1.5h1v1.5h-1zM1.5,-1.5h0.5v0.5h-0.5zM3,-1.5h1v0.5h-1zM5,-1.5h0.5v0.5h-0.5zM1.5,-1h1v1h-1zM4.5,-1h1v1h-1zM3,-0.5h1v0.5h-1zM2.5,0h0.5v0.5h-0.5zM4,0h0.5v0.5h-0.5z',
    },
    { paint: 'lanternGlow', d: 'M-1.5,-3h0.5v0.5h-0.5z' },
    {
      paint: 'fountainWater',
      d: 'M5.5,-0.5h0.5v0.5h-0.5zM1.5,0h1v0.5h-1zM4.5,0h1.5v0.5h-1.5zM2,0.5h3v0.5h-3z',
    },
    {
      paint: 'dock',
      d: 'M2.5,-3h2v0.5h-2zM2,-2.5h3v0.5h-3zM2,-1.5h1v0.5h-1zM4,-1.5h1v0.5h-1zM2.5,-1h2v0.5h-2zM2.5,-0.5h0.5v0.5h-0.5zM4,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'wheat',
      d: 'M3,-4h1v0.5h-1zM-3,-3.5h1.5v0.5h-1.5zM-3,-3h1v0.5h-1zM-1,-3h0.5v0.5h-0.5zM-3,-2.5h0.5v2h-0.5zM5.5,-2.5h0.5v0.5h-0.5zM-2,-2h1v0.5h-1zM5.5,-1.5h0.5v0.5h-0.5zM3,0h1v0.5h-1z',
    },
    { paint: 'boulder', d: 'M3,-2h1v0.5h-1z' },
  ],
  pixels: 196,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
